const slots = [
  "Bedriftskunde • Produksjon",
  "Bedriftskunde • Eiendom & Næring",
  "Bedriftskunde • Handel & Tjenester",
];

const TestimonialsSection = () => (
  <section className="py-20 bg-slate-50 border-b border-slate-200" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="max-w-xl mx-auto text-center mb-12">
        <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">
          Referanser &amp; Erfaring
        </span>
        <h2 className="font-serif-heading text-2xl sm:text-3xl font-bold text-[#0B132B] mt-2">
          B2B Kundehistorier
        </h2>
        <p className="text-xs text-slate-500 mt-2">
          Vi bygger langsiktige partnerskap med norske bedrifter.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {slots.map((slot) => (
          <div
            key={slot}
            className="p-6 rounded-xl bg-white border border-dashed border-slate-300 text-center flex flex-col items-center justify-center min-h-[160px]"
            data-testid={`testimonial-placeholder-${slot.split("•")[1].trim().toLowerCase().replace(/\s+/g, "-")}`}
          >
            <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
              Kundeuttalelse
            </span>
            <p className="text-sm text-slate-500 mt-2 italic">
              Publiseres fortløpende etter avtaleinngåelse
            </p>
            <span className="text-xs text-emerald-600 font-medium mt-3">{slot}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
